import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../contexts/ThemeContext';
import { BoxIcon } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: (e?: React.MouseEvent) => void;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  icon?: BoxIcon;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
}
export function Button({
  children,
  onClick,
  variant = 'primary',
  fullWidth = false,
  icon: Icon,
  disabled = false,
  type = 'button',
  className = ''
}: ButtonProps) {
  const {
    getThemeClasses,
    theme
  } = useTheme();
  const themeClasses = getThemeClasses();
  const baseClasses = `px-4 py-2 rounded-lg font-medium transition-all flex items-center justify-center gap-2 ${fullWidth ? 'w-full' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`;
  const variantClasses = variant === 'primary' ? `bg-gradient-to-r ${theme === 'neon' ? 'from-cyan-500 to-pink-500' : 'from-purple-500 to-pink-500'} text-white hover:shadow-lg` : `${themeClasses.card} border ${themeClasses.border} ${themeClasses.text} ${themeClasses.cardHover}`;
  return <motion.button type={type} onClick={onClick} disabled={disabled} className={`${baseClasses} ${variantClasses} ${className}`} whileHover={disabled ? {} : {
    scale: 1.02
  }} whileTap={disabled ? {} : {
    scale: 0.98
  }} data-id="element-908">
      {Icon && <Icon className="w-4 h-4" data-id="element-909" />}
      {children}
    </motion.button>;
}